// WINDOW EVENTS
export const CURRENCY_CHANGED_EVENT = 'currencyChange';

// TRACKING EVENTS
export const SPEED_DIAL_EVENT = 'speed_dial_actions';
export const SIDE_MENU_EVENT = 'side_menu';
export const CURRENCY_CONVERTER_EVENT = 'currency_converter';
export const WIDGET_CATEGORY_EVENT = 'widget_category';
export const AREA_WIDGET_EVENT = 'area_comparison_widget';
export const DATE_PICKER_EVENT = 'date_picker';
export const SIGN_IN_EVENT = 'sign_in';
export const SIGN_OUT_EVENT = 'sign_out';
export const THEME_SWITCH_EVENT = 'theme_switch';
export const LANGUAGE_SWITCH_EVENT = 'language_switch';
export const PAGE_NAVIGATION_EVENT = 'page_navigation';

const trackableEventNames = [
  'speed_dial_actions',
  'side_menu',
  'currency_converter',
  'widget_category',
  'area_comparison_widget',
  'date_picker',
  'sign_in',
  'sign_out',
  'theme_switch',
  'language_switch',
  'page_view',
] as const;

export type TrackableEventName = (typeof trackableEventNames)[number];

const trackableEventTypes = ['click', 'page', 'navigation'] as const;

export type TrackableEventType = (typeof trackableEventTypes)[number];

const trackablePageNames = [
  // Dashboard
  'home',
  'store_overview',
  'widget_access_control',
  'store_list',
  'area_result',

  // General
  'employees_and_roles',
  'transaction_search',
  'sales_analysis',
  'yearly_stock_take',

  // Customer Centric Insights
  'kpi_targets',
  'kpi_targets_history',
  'sold_products',
  'product_category',
  'product_category_garment',
  'profit_and_loss',

  // Profile
  'profile',
  'access_approvals',
] as const;

export type TrackablePageName = (typeof trackablePageNames)[number];
